const breakpointsNames = {
    xl : 'xl',
    lg : 'lg',
    md : 'md',
    sm : 'sm',
    xs : 'xs'
};

export default breakpointsNames;